import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { setRelevanceGroup, toggleTimelineActive } from '../../../actions/dataAction';
import moment from 'moment';
import styled from 'styled-components';
import {Line} from 'react-chartjs-2';
import Popover, {PopoverAnimationVertical} from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown';
import {Box, BoxButton} from '../../StyledComponents';
import Loading from '../../Loading.js';

import MediaQuery from 'react-responsive';
import Media from "react-media";


import IconButton from 'material-ui/IconButton';

import ToggleCheckBoxOutlineBlank from 'material-ui/svg-icons/toggle/check-box-outline-blank';
import ToggleCheckBox from 'material-ui/svg-icons/toggle/check-box';


/**
* Colors
*/
//const themeColors = ['#5ab99a', '#fa7823', '#b21fd1', '#0e67b9', '#9674a0', '#d26565', '#7b4172', '#e7969c', '#a55094', '#843c39'];
const themeColors = [
  "#f49e6d",
  "#b9b84c",
  "#fd7923",
  "#daa8e3",
  "#a6050e",
  "#ee5a5d",
  "#9edfa6",
  "#aed4fd"
];

/**
* Styled components
*/
const RelevanceViewContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 991px) {
    min-height: 500px;
  }

  @media only screen and (max-width: 524px) {
    min-height: 450px;
  }

`;

const MainHeadingBig = styled.h1`
  text-transform: uppercase;
  margin-bottom: 20px;
  margin-top: 0;
`;

const ChartDescription = styled.h4`
  text-align: center;
  color: #929698;
  padding-left: 20%;
  padding-right: 20%;
  margin-bottom: 30px;

  @media only screen and (max-width: 767px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const SmallerRow = styled.div`
  padding-left: 5%;
  padding-right: 5%;

  @media only screen and (max-width: 767px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const ChartDataContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const DataContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-bottom: 20px;

  @media only screen and (max-width: 524px) {

  }

  @media print {
    -webkit-print-color-adjust: exact;
  }
`;

const DataInnerContainer = styled.div`
  width: 100%;
`;

const IconRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const IconData = styled.span`
  margin-right: 5px;
  height: 14px;
  width: 14px;
  border-radius: 50% !important;
  display: inline-block;
`;

const TitleData = styled.p`
  color: #c3c3c3;
  margin-bottom: 0;
  line-height: 12px;
  display: block;
  font-size:16px;
`;

const InfoContainer = styled.div`
  display: flex;

  @media only screen and (max-width: 524px) {
    flex-direction: column;
  }
`;

const OptionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 15px;
  padding-bottom: 10px;
  padding-right: 0;
  padding-left: 0;

  @media only screen and (max-width: 524px) {
    margin-bottom: 0;
  }
`;

const InnerOptionContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
`;

const AngleDown = styled(FontAwesomeIcon)`
  margin-left:10px;
`;

const XChartPopover = styled(Popover)`
  border-radius: 3px !important;
`;

const XChartMenu = styled(Menu)`
  background-color: #fff !important;
  color: #333 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;

  > div > span {
    font-size: 10px !important;
    text-transform: uppercase !important;
    text-align: center !important;
    min-height: 26px !important;
    -webkit-transition: all 0.15s ease-in-out !important;
    -moz-transition: all 0.15s ease-in-out !important;
    -o-transition: all 0.15s ease-in-out !important;
    transition: all 0.15s ease-in-out !important;

    &:hover {
      color: #fff !important;
      background-color: #71bfa6 !important;
    }

    > div {
      line-height: 26px !important;
    }
  }
`;

const ChartContainer = styled.div`
  flex: 1;

  @media print {
    min-height: 200px;
  }
`;

const LineChartMenu = styled(Menu)`
  background-color: #fff !important;
  color: #333 !important;

  > div > span {
    font-size: 12px !important;
    min-height: 26px !important;

    > div {
      line-height: 26px !important;
      > div {
        padding: 0 2px 0 32px !important;
        > svg {
          margin: 5px 8px !important;
          height: 16px !important;
          width: 16px !important;
        }

        > div {
          color: rgba(0, 0, 0, 0.87) !important;
        }
      }
    }
  }
`;

/**
* Class RelevanceChartView
*/

class RelevancePerformanceView extends Component {

  constructor(props) {
    super(props)

    this.state = {
      firstPopoverOpen: false,
      secondPopoverOpen: false,
    };

    this.handleXChart = this.handleXChart.bind(this);
  }

  translateData(data, group) {
    if (_.isEmpty(data)) {
      return {};
    };

    let values = data;

    if (typeof values === 'string' || values instanceof String) {
      values = JSON.parse(data);
    };

    const datapoints = [
      {id: "rlv", label:"Relevance", color:themeColors[0]},
      {id: "index", label:"Index", color:themeColors[1]},
    ];
    let datasets = [];
    let labels = [];

    _.forEach(values, function(val) {
      switch (group) {
        case 'month':
            labels.push(moment(val.date).format('MMMM -YY'));
          break;
        case 'quarter':
            labels.push("Q" + moment(val.date).quarter() + " -" + moment(val.date).format("YY"));
          break;
        default:
            labels.push("Q" + moment(val.date).quarter() + " -" + moment(val.date).format("YY"));
          break;
      }
    });

    // Build datasets
    _.forEach(datapoints, function(datapoint, i) {
      let chartValues = [];
      _.forEach(values, function(val) {
        if (val.hasOwnProperty(datapoint.id)) {
          chartValues.push(parseFloat(val[datapoint.id].score).toFixed(2));
        } else if (datapoint.id === 'index') {
          //chartValues.push(parseFloat(val["rlv"].index).toFixed(2));
          //chartValues.push(parseFloat(1));

        };
      });

      const dataset = {
        data: chartValues,
        label: datapoints[i].label,
        color: datapoint.color,
        borderColor: datapoint.color, //i
        pointBorderColor: datapoint.color, //i
        pointBackgroundColor: datapoint.color, //i
        fill: false,
      };


      datasets.push(dataset);

    });



    const dataOut = {
      labels: labels,
      datasets: datasets
    }

    return dataOut;
  }


  renderChartLegend(data) {
    let values = [
      {label: "Relevance", color: themeColors[0]},
      /* {label: "Competitor index", color: themeColors[1]} */
    ];
    return _.map(values, (dataValue, key) => {
      return (
        <DataInnerContainer key={key}>
          <IconRow>
            <IconData style={{backgroundColor: dataValue.color}}></IconData>
            <TitleData>{dataValue.label}</TitleData>
          </IconRow>
        </DataInnerContainer>
      );
    });
  }

  handleClick = (name ,event) => {
    event.preventDefault();

    this.setState({
      [name]: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = (name) => {
    this.setState({
      [name]: false,
    });
  };

  handleXChart(event, value) {
    this.props.setRelevanceGroup(value.toLowerCase());
  }

  toggleVariableActive(value) {
    let inactiveVars = this.state && this.state.inactiveVars ? this.state.inactiveVars : [];
    if (inactiveVars.indexOf(value) > -1) {
      inactiveVars.splice(inactiveVars.indexOf(value), 1);
    } else {
      inactiveVars.push(value);
    }
    this.setState({inactiveVars: inactiveVars});
  }

  renderVariableToggleMenuItems(data) {
    const _this = this;
    let inactiveVars = this.state && this.state.inactiveVars ? this.state.inactiveVars : [];

    let menuItems = [];
    _.forEach(data.datasets, function(obj, i) {
      const isInactive = (inactiveVars.indexOf(obj.label) > -1);
      menuItems.push(<MenuItem key={i+obj.label} primaryText={obj.label} value={obj.label} onClick={() => _this.toggleVariableActive(obj.label)} leftIcon={isInactive ? <ToggleCheckBoxOutlineBlank />:<ToggleCheckBox />} />);
    });

    return (
        <LineChartMenu multiple={true}>
          {menuItems}
        </LineChartMenu>
    );
  }

  skipInactiveVars(data) {
    let datasets = data.datasets || [];
    let inactiveVars = this.state && this.state.inactiveVars ? this.state.inactiveVars : [];

    _.remove(datasets, function (el) {
      return (inactiveVars.indexOf(el.label) > -1);
    });

    data.datasets = datasets;
    return data;
  }

  timelineActive() {
      return process.env.REACT_APP_TIMELINE_ACTIVE === "true";
  }

  render() {
      const { rawData } = this.props;
      if (!rawData.relevanceData) {
        return <Box><Loading fullHeight={true}/></Box>;
      }

      const group = rawData.relevanceGroup;

      //const groupData = rawData.relevanceData[group] || {};
      const groupData = rawData.relevanceData.data;

      const data = groupData || {};
      const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontColor: '#fff',
              fontSize: 10,
            },
            gridLines: {
              color: '#333333',
              zeroLineColor: '#333',
              lineWidth: 0.5,
            }
          }],
          xAxes: [{
            display: true,
            ticks: {
              fontColor: '#fff',
              fontSize: 10,
            }
          }]
        },
        elements: {
          line: {
            tension: 0,
            borderWidth: 1,
          }
        },
        animation: {
          duration:0
        }
      }

      const chartData = this.translateData(data, group);
      return (
          <Box>
            <RelevanceViewContainer>
              <SmallerRow>
                <MainHeadingBig className="big-font-size">Relevance{this.props.user && this.props.user.userProfile && (": "+(this.props.user.userProfile.clientName || this.props.user.userProfile.client))}</MainHeadingBig>
              </SmallerRow>

              <ChartDescription style={data.description ? {} : {display: 'none'}}>{data.description ? data.description : ''}</ChartDescription>

              <ChartDataContainer className="row">
                <SmallerRow>
                  <InfoContainer>
                    <DataContainer className="col-xs-12 col-sm-6 col-md-6">
                      {this.renderChartLegend(chartData)}
                    </DataContainer>
                    <OptionContainer className="col-xs-12 col-sm-6 col-md-6">

                      <InnerOptionContainer>
                        {<BoxButton onClick={this.handleClick.bind(this, 'firstPopoverOpen')}>
                          <span>{group}<AngleDown icon={faAngleDown}></AngleDown></span>
                        </BoxButton>}

                        {this.timelineActive() && (
                          <BoxButton onClick={() => this.props.toggleTimelineActive(this.props.rawData.timelineActive ? false:true)} className="margin-right hidden-xs">
                            <span>{moment(rawData.startDate).format("YYYY-MM-DD")} - {moment(rawData.endDate).format("YYYY-MM-DD")}</span>
                          </BoxButton>
                        )}

                        <XChartPopover
                          open={this.state.firstPopoverOpen}
                          anchorEl={this.state.anchorEl}
                          anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                          targetOrigin={{horizontal: 'left', vertical: 'top'}}
                          onRequestClose={this.handleRequestClose.bind(this, 'firstPopoverOpen')}
                          animation={PopoverAnimationVertical}
                        >
                          <XChartMenu onChange={this.handleXChart} value={group} width="100px" autoWidth={false} selectedMenuItemStyle={ {backgroundColor: '#56ba9a', color: '#fff'} }>
                            <MenuItem primaryText="Month" value="Month" />
                            <MenuItem primaryText="Quarter" value="Quarter" />
                          </XChartMenu>
                        </XChartPopover>

                      </InnerOptionContainer>

                    </OptionContainer>
                  </InfoContainer>
                </SmallerRow>

                <ChartContainer className="col-xs-12 col-sm-12 col-md-12">
                  <MediaQuery print={true}>
                    <h1>qqq</h1>
                  </MediaQuery>

                  <Media query={{print: true}}>
                    <h1>haaay</h1>
                  </Media>
                  <Line data={this.skipInactiveVars(chartData)} options={chartOptions} />
                </ChartContainer>

              </ChartDataContainer>

            </RelevanceViewContainer>
          </Box>
      );

  }
}

function mapStateToProps(state, ownProps) {
    return {
      rawData: state.data,
      uid: state.user.uid,
      user: state.user
    };
}

export default connect(mapStateToProps, { setRelevanceGroup, toggleTimelineActive })(RelevancePerformanceView);

/*
const data = [
  {
    "date": "2017-04-01",
    "prc": 30.73406945383353,
    "prd": 57.96306307330425,
    "prm": 36.34002549577291,
    "prp": 34.049464825130364,
    "ppl": 48.76438843781467,
    "prf": 42.36764847088902,
    "rlv": 21.82389729542808
  },
  {
    "date": "2017-05-01",
    "prc": 28.762931130895193,
    "prd": 54.473030744976676,
    "prm": 35.459690644579986,
    "prp": 28.177485616820636,
    "ppl": 41.8786831744919,
    "prf": 37.84009333683704,
    "rlv": 19.699852688391033
  }
]
*/



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/RelevancePerformance.js